﻿import { Flex, Text } from "@mantine/core";
import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import DisplayIcon from './iconSelector/DispalyIcon';
import CustomButton from './ui/Buttons/CustomButton';
import CustomCard from "./ui/combobox/CustomCard/CustomCard";
import { ROUTES } from "../routes/paths";

export const noDataConfig: PageHeaderConfig[] = [

  {
    url: ROUTES.home,
    heading: "Home",
    paragraph: "Overview of your dashboard and quick access to key features.",
    icon: "Home",
    color: "blue",
    showButton: false
  },
  {
    url: ROUTES.inbox,
    heading: "No Inbox found to be displayed",
    paragraph: "No Documents are available.",
    icon: "Inbox",
    color: "blue",
    showButton: false


  },

  // PEOPLE
  {
    url: ROUTES.people.activeTeamMembers,
    heading: "No Active found to be displayed",
    paragraph: "No Active Team Member have been added to the system yet.",
    icon: "Users",
    color: "gray",
    showButton: true,
    buttonText: "Add Team Member",
    buttonRoute: ROUTES.people.addTeamMembers
  },

  {
    url: ROUTES.people.onboarding,
    heading: "No Onboarding found to be displayed",
    paragraph: "No Onboarding Team Member have been added to the system yet.",
    icon: "Users",
    color: "gray",
    showButton: true,
    buttonText: "Add Team Member",
    buttonRoute: ROUTES.people.addTeamMembers
  },

  {
    url: ROUTES.people.offboarding,
    heading: "No Offboarding found to be displayed",
    paragraph: "No Offboarding Team Member have been added to the system yet.",
    icon: "Users",
    color: "gray",
    showButton: true,
    buttonText: "Add Team Member",
    buttonRoute: ROUTES.people.addTeamMembers
  },

  {
    url: ROUTES.people.separated,
    heading: "No Seperated found to be displayed",
    paragraph: "No Seperated Team Member have been added to the system yet.",
    icon: "Users",
    color: "gray",
    showButton: false
  },

  {
    url: ROUTES.people.teamMemberProfile,
    heading: "Profile",
    paragraph: "View and update team member profile information.",
    icon: "UserCircle",
    color: "gray",
    showButton: false
  },

  // PROJECTS
  {
    url: ROUTES.projects.details,
    heading: "No Projects found to be displayed",
    paragraph: "No Projects have been added to the system yet. Add your first Projects to get started.",
    icon: "SquareLetterP",
    color: "gray",
    showButton: true,
    buttonText: "Add Project",
    buttonRoute: ROUTES.projects.add
  },

  // COMPANY
  {
    url: ROUTES.company.details,
    heading: "No Company found to be displayed",
    paragraph: "No Company has been added to the system yet. Add your first Company to get started.",
    icon: "ListDetails",
    color: "red",
    showButton: true,
    buttonText: "Add Company",
    buttonRoute: ROUTES.company.add
  },

  {
    url: ROUTES.company.hrDocuments,
    heading: "Please Define Page Configuration",
    paragraph: "No documents found. Please add a new page configuration to view documents.",
    icon: "File",
    color: "pink",
    showButton: false
  },

  // CUSTOMERS
  {
    url: ROUTES.customers.details,
    heading: "No Customer found to be displayed",
    paragraph: "View and manage customer information.",
    icon: "CreativeCommonsBy",
    color: "gray",
    showButton: true,
    buttonText: "Add Customer",
    buttonRoute: ROUTES.customers.add
  },

  {
    url: ROUTES.customers.documents,
    heading: "Please Define Page Configuration",
    paragraph: "No documents found. Please add a new page configuration to view documents.",
    icon: "File",
    color: "gray",
    showButton: false
  },

  // SUPPLIERS
  {
    url: ROUTES.suppliers.details,
    heading: "No Supplier found to be displayed",
    paragraph: "No Supplier has been added to the system yet. Add your first Supplier to get started.",
    icon: "CreativeCommonsBy",
    color: "gray",
    showButton: true,
    buttonText: "Add Supplier",
    buttonRoute: ROUTES.suppliers.add
  },

  {
    url: ROUTES.suppliers.documents,
    heading: "No Page Configuration found to be displayed",
    paragraph: "No documents found. Please add a new page configuration to view documents.",
    icon: "File",
    color: "red",
    showButton: false
  },

  // ASSETS
  {
    url: ROUTES.assets,
    heading: "No Assets found to be displayed",
    paragraph: "No Assets have been added to the system yet. Add your first Assets to get started.",
    icon: "DeviceDesktop",
    color: "gray",
    showButton: true,
    buttonText: "Add New Asset",
    buttonRoute: ROUTES.assets
  },

  // ADMINISTRATION
  {
    url: ROUTES.administration.usersAndRoles,
    heading: "No Users & Roles found to be displayed",
    paragraph: "Add and manage users while assigning appropriate roles to control system access.",
    icon: "UserSearch",
    color: "gray",
    showButton: false
  },

  // MY DOCUMENTS
  {
    url: ROUTES.myDocuments,
    heading: "No My Documents found to be displayed",
    paragraph: "Upload and organize your personal documents",
    icon: "Files",
    color: "gray",
    showButton: false
  },

  {
    url: "/roles&Permissions/mappingNavMenus",
    heading: "No Mapping NavMenus found to be displayed",
    paragraph: "Configure and manage navigation menu mappings for different roles.",
    icon: "Files",
    color: "gray",
    showButton: false
  },

  {
    url: "/roles&Permissions/managePermissions",
    heading: "No Manage Permissions found to be displayed",
    paragraph: "Set up and manage permissions to control what users can access and do in the system.",
    icon: "Files",
    color: "gray",
    showButton: false
  }
];

export type PageHeaderConfig = {
  url?: string;
  heading?: string;
  paragraph?: string;
  icon?: string;
  color?: string;
  showButton?: boolean;
  buttonText?: string;
  buttonRoute?: string;
};

interface Props {
  title?: string;
  dataType?: string;
  condition?: string;
  iconName?: string;
  text?: string;
  iconColor?: string;
  textColor?: string;
  height?: number;
  width?: string | number;
  iconWidth?: number
  iconHeight?: number
  textSize?: number | string
  withBorder?: boolean;
  description?: string;
  buttonText?: string;
  onButtonClick?: () => void;
  onButtonClick2?: () => void;
  bg?: string;
  hoverBorderColor?: string;
  buttonText2?: string;
  mt?: number | string;
  isNoRadius?: boolean;
  isHomeNotify?: boolean;
  radius?: string;
}

interface TableNoDataFoundProps {
  title: string;
  iconName?: string;
  iconColor?: string;
  height?: number;
  heading?: string;
  description?: string;
  contentWidth?: string;

}

const NoDataFound = ({ title, dataType, condition, description }: Props) => {
  return (
    <Flex direction={'column'} align={'center'} justify={'center'} gap={8}>
      <DisplayIcon iconName={'CircleOff'} width={24} height={24} iconColor={'#94A3B8'} isHover={true} />
      <Text tt={'uppercase'} fz={'0.75rem'} c='#94A3B8' fw={900}>No {title} {dataType} found {condition ? condition : ''} to be displayed</Text>
      {description && (
        <Text c={'rgb(148 163 184)'} fz={'0.75rem'} fw={700}>
          {description}
        </Text>
      )}
    </Flex>
  )
}
export default NoDataFound;

export const TableNoDataFound = ({
  title,
  iconName = 'CircleOff',
  iconColor = 'rgb(171, 176, 182)',
  height = 220,
  heading,
  description,
  contentWidth,
}: TableNoDataFoundProps) => {
  return (
    <Flex direction={'column'} p={'1rem 2rem'} justify={'center'} align={'center'} h={height} gap={8} style={contentWidth ? { width: contentWidth } : undefined}>
      <DisplayIcon iconName={iconName} width={30} height={30} iconColor={iconColor} isHover={true} />
      <Text c={'#0F172A'} tt={'uppercase'} fz={'0.75rem'} fw={900}>{heading ?? `No ${title} found to be displayed`}</Text>
      <Text c={'rgb(148 163 184)'} fz={'0.75rem'} fw={700}>{description ?? `No ${title} records have been added to the system yet.`}</Text>
    </Flex>
  );
};

export const NoDataFoundCard = ({ mt, text, description, buttonText, onButtonClick, onButtonClick2, iconName, textColor, height, width, textSize, iconWidth, withBorder = true, bg, hoverBorderColor, buttonText2, isNoRadius = false, isHomeNotify = false, radius }: Props) => {
  const location = useLocation();

  // const noData = noDataConfig.find(
  //   item => item.url === location.pathname
  // );
  // const noData = useMemo(() => {
  //   return noDataConfig.find(item => item.url === location.pathname);
  // }, [location.pathname]);
  const noData = useMemo(() => {
    const sortedRoutes = [...noDataConfig].sort(
      (a, b) => (b.url?.length || 0) - (a.url?.length || 0)
    );

    return sortedRoutes.find(route =>
      location.pathname.startsWith(route.url || "")
    );
  }, [location.pathname]);

  const navigate = useNavigate();
  const handleButtonClick = () => {
    if (noData?.buttonRoute) {
      navigate(noData.buttonRoute);
    }
  };

  return (
    <CustomCard mb={0} bg={bg || 'rgb(255 255 255)'} w={width} withBorder={withBorder} hoverBorderColor={hoverBorderColor} padding="1rem 2rem" mt={mt || 0} isCustomRadius={isNoRadius} radius={radius}>
      <Flex direction={'column'} justify={'center'} align={'center'} h={height || 220} gap={8} p={isHomeNotify ? '0rem' : '1rem'} >
        <DisplayIcon
          iconName={iconName || noData?.icon || ''}
          width={iconWidth || 30}
          height={30}
          iconColor={'#94A3B8'}
          isHover={true}
        />
        {/* {iconName && <CustomIcon color={iconColor || 'rgb(203 213 225)'} iconType={iconName || 'Plus'} h={iconHeight || 35} w={iconWidth || 35} hoverColor={iconColor || 'rgb(203 213 225)'} />} */}
        <Text c={textColor || '#0F172A'} tt={'uppercase'} fz={textSize || '0.75rem'} fw={900}>{text || noData?.heading}</Text>
        {(description || noData?.paragraph) && <Text c={textColor || 'rgb(148 163 184)'} fz={textSize || '0.75rem'} fw={700}>{description || noData?.paragraph}</Text>}
        {(buttonText || noData?.showButton) && (
          <Flex mt={6} mb={'2rem'} gap={'sm'}>
            {buttonText2 && <CustomButton onClick={onButtonClick2 || handleButtonClick} buttonType='footerButton' text={buttonText2 || noData?.buttonText || ""} height={30} fz={11} btnWidth={2} fw={900} />}
            <CustomButton onClick={onButtonClick || handleButtonClick} variant='default' buttonType='footerButton' text={buttonText || noData?.buttonText || ""} height={30} fz={11} btnWidth={2} color='#475569 !important' fw={900} />
          </Flex>
        )}
      </Flex>
    </CustomCard>
  )
}
